import { Button, Container, lighten } from '@material-ui/core';
import styled from 'styled-components';

export const ContainerDiv = styled(Container)`
  display: flex;
  flex-direction: column;

  .title {
    display: contents;
  }
`;

export const MainDiv = styled.div`
  margin-top: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > img {
    width: 400px;
    margin: 50px 0;
  }

  form {
    width: 100%;
    margin-top: 10px;
  }
`;

export const ButtonBlue = styled(Button)`
  && {
    background-color: #6b0a95;
    margin: 5px 0 10px;
    color: #fff;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;

    &:hover {
      background-color: ${lighten('#6b0a95', 0.2)};
    }
  }
`;
